import { render, staticRenderFns } from "./CoursewareStructuralElementDialogCopy.vue?vue&type=template&id=a41308ac&"
import script from "./CoursewareStructuralElementDialogCopy.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementDialogCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports